export const INTRO_CONSTANTS = {
  title: "Proactive Risk Reduction — Powered by AI & Intelligence ",
  text: "OneMind helps you stay ahead of threats by eliminating software vulnerabilities before they’re exploited. Through deep integration with Tenable, Red Hat, our platform continuously scans your entire environment and automates patching — so your team can focus on what matters, not what’s missing. ",
};
